import * as React from 'react'

const SvgExportIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 15v2.5H3.75V15H2.5v2.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V15h-1.25zM3.75 7.5l.881.875 4.744-4.731v11.981h1.25V3.644l4.744 4.731.881-.875L10 1.25 3.75 7.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgExportIcon
